import mutations from './incidentRegistration.mutations'
import actions from './incidentRegistration.actions'
import getters from './incidentRegistration.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
